import config from "@/config";

export function getBaseUrl() {
  return (
    config?.BASE_URL ||
    process.env.VUE_APP_BASE_URL ||
    '/api/v1'
  );
}